/**
 * Permission checks, mirroring the API's own rules.
 *
 * This decides what a person is *shown*. It is never the security boundary - the
 * API checks the same codes on every call, and a hidden button is a courtesy, not
 * a control. Both exist because a screen full of actions that all answer 403 is a
 * worse product than one that shows what you can actually do.
 */

export type Scope = 'none' | 'own' | 'team' | 'any'

export function has(permissions: readonly string[], code: string): boolean {
  return permissions.includes(code)
}

export function hasAny(permissions: readonly string[], ...codes: string[]): boolean {
  return codes.some((code) => permissions.includes(code))
}

/** The widest scope held of `<resource>.<action>.own|team|any`. */
export function scopeOf(permissions: readonly string[], resourceAction: string): Scope {
  if (permissions.includes(`${resourceAction}.any`)) return 'any'
  if (permissions.includes(`${resourceAction}.team`)) return 'team'
  if (permissions.includes(`${resourceAction}.own`)) return 'own'

  return 'none'
}

export function canSee(permissions: readonly string[], resourceAction: string): boolean {
  return scopeOf(permissions, resourceAction) !== 'none'
}
